/**
 * Phase 17 — Rechnungen lesen: entity_invoices + merged Blob.
 */

import { listAggregateInvoices } from '../infrastructure/storage/domainAggregateStore';
import { listEntityInvoices } from '../infrastructure/storage/entityAggregateStore';
import { readBlobFirstWithAggregateFallback } from './canonicalEntityRead';
import { readSyncWithBlobPriority, readArrayFieldFromMergedBlob } from './businessStateSync';

/** @type {Map<string, object[]>} */
const invoicesReadCache = new Map();

export function readInvoicesFromMergedBlob(businessId) {
  return readArrayFieldFromMergedBlob(businessId, 'invoices', getCachedInvoicesRead);
}

export async function readInvoicesFromBestSource(businessId) {
  return readBlobFirstWithAggregateFallback(
    businessId,
    readInvoicesFromMergedBlob,
    listAggregateInvoices,
    listEntityInvoices,
    ['id', 'invoiceNumber']
  );
}

export async function refreshInvoicesReadCache(businessId, preloaded) {
  const invoices =
    preloaded !== undefined
      ? Array.isArray(preloaded)
        ? preloaded
        : []
      : await readInvoicesFromBestSource(businessId);
  if (businessId) {
    invoicesReadCache.set(String(businessId), invoices);
  }
  return invoices;
}

export function getCachedInvoicesRead(businessId) {
  if (!businessId) return null;
  return invoicesReadCache.get(String(businessId)) ?? null;
}

export function clearInvoicesReadCache(businessId) {
  if (businessId) {
    invoicesReadCache.delete(String(businessId));
  } else {
    invoicesReadCache.clear();
  }
}

export function readInvoicesSyncForBusiness(businessId) {
  return readSyncWithBlobPriority(
    businessId,
    readInvoicesFromMergedBlob,
    getCachedInvoicesRead,
    'id',
    'invoiceNumber'
  );
}
